/**
 * Email signup creates the account, then signs the browser out so the navbar stays
 * signed-out until the set-password link. The ID token captured just before that
 * sign-out lets FoxChat SAVE attach the finished collage to that account without
 * asking for the email again. sessionStorage only; the token dies with the tab
 * and is ignored once it expires.
 */

const STORAGE_KEY = 'foxChatEmailSignupAttach';

function decodeJwtExp(idToken) {
  try {
    const part = idToken.split('.')[1];
    if (!part || typeof atob !== 'function') return null;
    const json = JSON.parse(atob(part.replace(/-/g, '+').replace(/_/g, '/')));
    return typeof json.exp === 'number' ? json.exp : null;
  } catch {
    return null;
  }
}

export function rememberEmailSignupAttachSession({ idToken, uid }) {
  if (!idToken || !uid || typeof sessionStorage === 'undefined') return;
  const exp = decodeJwtExp(idToken);
  try {
    sessionStorage.setItem(STORAGE_KEY, JSON.stringify({ idToken, uid, exp }));
  } catch {
    /* private mode / quota — SAVE falls back to the signup popup */
  }
}

export function readEmailSignupAttachSession() {
  if (typeof sessionStorage === 'undefined') return null;
  try {
    const raw = sessionStorage.getItem(STORAGE_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    if (!parsed || typeof parsed.idToken !== 'string' || typeof parsed.uid !== 'string') {
      sessionStorage.removeItem(STORAGE_KEY);
      return null;
    }
    const now = Math.floor(Date.now() / 1000);
    if (!parsed.exp || parsed.exp < now + 30) {
      sessionStorage.removeItem(STORAGE_KEY);
      return null;
    }
    return { idToken: parsed.idToken, uid: parsed.uid };
  } catch {
    return null;
  }
}

export function clearEmailSignupAttachSession() {
  if (typeof sessionStorage === 'undefined') return;
  try {
    sessionStorage.removeItem(STORAGE_KEY);
  } catch {
    /* ignore */
  }
}
